import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PipesModule } from 'pipes';
import { ImageComponent } from './image.component';

const components = [ImageComponent];

@NgModule({
    imports: [CommonModule, PipesModule],
    declarations: components,
    exports: components
})
export class ImageModule {}
